import React from "react";
const SvgLoginAddNotes = props => (
  <svg fill="none" viewBox="0 0 33 32" {...props}>
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M10.25 11.5a.75.75 0 01.75-.75h4a.75.75 0 010 1.5h-4a.75.75 0 01-.75-.75zm0 4.6a.75.75 0 01.75-.75h10a.75.75 0 010 1.5H11a.75.75 0 01-.75-.75zm0 4.6a.75.75 0 01.75-.75h10a.75.75 0 110 1.5H11a.75.75 0 01-.75-.75z"
      clipRule="evenodd"
    />
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M9 5.75A3.25 3.25 0 005.75 9v14a3.251 3.251 0 003.252 3.25h13.996A3.251 3.251 0 0026.25 23v-8.1a.75.75 0 011.5 0V23a4.751 4.751 0 01-4.752 4.75H9.002A4.751 4.751 0 014.25 23V9A4.75 4.75 0 019 4.25h10.3a.75.75 0 010 1.5H9z"
      clipRule="evenodd"
    />
    <path
      fill="#F095A6"
      d="M23.925 13.479l-4.425.018V9.06c0-.446.186-.892.502-1.207L26.863 1a1.708 1.708 0 012.417 0l2.715 2.711a1.7 1.7 0 010 2.414l-6.861 6.851a1.736 1.736 0 01-1.209.502z"
    />
    <path
      fill="#E4002B"
      d="M30.502 6.904L26.08 2.482l-.352-.352.273.273-.27-.27 1.135-1.132a1.708 1.708 0 012.417 0l2.715 2.711a1.7 1.7 0 010 2.414L30.86 7.262l-.004-.004-.354-.354z"
    />
  </svg>
);
export default SvgLoginAddNotes;
